import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/bd-mobile-next/app/(main)/view-cart/page.tsx");
